import React, { useEffect, useRef, useState } from "react";
import { Button, Form, Col, Row, Modal } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";

import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  resetData,
  selectData,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  fetchData,
  uploadItem,
  uploadValidate,
  fetchExport,
} from "./pricelistSlice";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import {
  CallApiExport,
  createChangeHandler,
  formatCurrency,
  formatterStatus,
  getValueStatus,
  paramsMasterAll,
  setOptionsMaster,
  setOptionsSelect,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
} from "../../utility";
import { PricelistTable } from "./PricelistTable";
import { fetchSynch, selectDataSynch } from "../company/companySlice";
import Select from "react-select";
import { headerSortingClasses, sortCaret } from "../../../_metronic/_helpers";
import BootstrapTable from "react-bootstrap-table-next";
import { fetchTemplate, selectLoadingTemplate } from "../product/productSlice";
import { fetchParam, selectDataParam } from "../param/paramSlice";

export const PricelistPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const data = useSelector(selectData);
  const loading = useSelector(selectLoading);
  const loading2 = useSelector(selectLoadingTemplate);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const dataParam = useSelector(selectDataParam);

  // Filter
  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [group, setGroup] = useState("");
  const [optionsGroup, setOptionsGroup] = useState([]);
  const ref = useRef();

  const paramsFilter = {
    pricelist_name: name,
    customer_group: group,
  };

  useEffect(() => {
    // Reset on first load
    dispatch(resetData());
  }, [dispatch]);

  useEffect(() => {
    async function fetchMyAPI() {
      await dispatch(
        fetchParam({
          ...paramsMasterAll,
          param_group_code: "CUSTOMER_GROUP",
          is_active: true,
        })
      );

      await dispatch(fetchData({ pageNo: 1, pageSize: 10 }));
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataParam.length > 0) {
      setOptionsMaster(dataParam, setOptionsGroup, "param_code", "param_value");
    }
  }, [dataParam]);

  console.log(optionsGroup);

  const handleChangeGroup = createChangeHandler(setGroup);

  const handleSearch = async () => {
    const params = {
      ...paramsFilter,
      pageNo: 1,
      pageSize: 10,
    };

    try {
      const response = await dispatch(fetchData(params));
      if (response.payload.data.status_code === 200) {
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleTableChange = async (
    type,
    { page, sizePerPage, sortField, sortOrder, data }
  ) => {
    if (type === "pagination") {
      const params = {
        ...paramsFilter,
        pageNo: page,
        pageSize: sizePerPage,
      };
      try {
        const response = await dispatch(fetchData(params));
        if (response.payload.data.status_code === 200) {
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    } else {
      const response = await dispatch(
        fetchData({
          ...paramsFilter,
          sort_order: sortOrder,
          sort_field: sortField,
          pageNo: 1,
          pageSize: sizePerPage,
        })
      );
      let result;
      if (sortOrder === "asc") {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return 1;
          } else if (b[sortField] > a[sortField]) {
            return -1;
          }
          return 0;
        });
      } else {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return -1;
          } else if (b[sortField] > a[sortField]) {
            return 1;
          }
          return 0;
        });
        console.log(result, "desc");
      }
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  return loading || loading2 ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Card>
        <CardHeader title="Price list">
          <CardHeaderToolbar>
            <Button
              className="btn btn-outline-danger mr-4"
              onClick={() =>
                CallApiExport(paramsFilter, fetchExport, dispatch, "Product")
              }
            >
              Export
            </Button>
            <Button
              className="btn btn-danger"
              onClick={() => history.push("/master/pricelist/create")}
            >
              Create
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          {/* Filter */}
          <Form className="mb-5">
            <Form.Group as={Row}>
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Customer Group</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Select
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      options={optionsGroup}
                      value={getValueStatus(group, optionsGroup)}
                      placeholder="Select ..."
                      onChange={handleChangeGroup}
                      isClearable={true}
                    />
                  </Col>
                </Form.Group>
              </Col>

              {/* Right Row */}

              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Pricelist Name</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      onKeyPress={handleKeyPress}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Col sm={3}>
                    <Button
                      className="btn btn-outline-danger"
                      onClick={handleSearch}
                    >
                      Search
                    </Button>
                  </Col>
                  {/* <Col sm={3}>
                  <Button
                    className="btn btn-warning"
                    onClick={() => history.push("/masterdata/vendor-create")}
                  >
                    Create
                  </Button>
                </Col> */}
                </Form.Group>
              </Col>
            </Form.Group>
          </Form>

          {/* Table */}
          <PricelistTable
            data={Array.isArray(data) ? data : []}
            page={pageNo}
            sizePerPage={pageSize}
            totalSize={totalRecord}
            onTableChange={handleTableChange}
            loading={loading}
          />
        </CardBody>
      </Card>
    </>
  );
};
